import React, { Component } from 'react'
import '../../App.css'
import axios from 'axios';
import {Link} from 'react-router-dom'

import Spinner from '../Layouts/Spinner'

export default class Lyrics extends Component {

    state = {
        track: {},
        lyrics: {}
    }

    componentDidMount() {
        axios.get(`https://cors-anywhere.herokuapp.com/https://api.musixmatch.com/ws/1.1/track.lyrics.get?track_id=${this.props.match.params.id}&apikey=${process.env.REACT_APP_API_KEY}`)
            .then(res => {
                this.setState({lyrics: res.data.message.body.lyrics})
                return axios.get(`https://cors-anywhere.herokuapp.com/https://api.musixmatch.com/ws/1.1/track.get?track_id=${this.props.match.params.id}&apikey=${process.env.REACT_APP_API_KEY}`)
            })
            .then(res => {
                this.setState({track: res.data.message.body.track})
            })
            .catch(error => console.log(error))
    }

    render() {
        const {track,lyrics} = this.state
        console.log(track)
        if(track === undefined || lyrics === undefined || Object.keys(track).length === 0 || Object.keys(lyrics).length === 0) {
            return <Spinner/>
        }
        return (
            <React.Fragment>
                <br/>
                <Link to="/" className="btn btn-sm" style={{backgroundColor: '#2B2B52', color: '#fff', marginBottom: 15}} ><strong>Back</strong></Link>
                <div className="card">
                    <h5 className="card-header" style={{fontFamily: 'Source Sans Pro'}}>
                        {track.track_name}
                        <span className="text-secondary"> ({track.artist_name})</span>
                    </h5>
                    <div className="card-body">
                        <div className="card-text">
                            <p>{lyrics.lyrics_body}</p>
                        </div>
                    </div>
                </div>
                <ul className="list-group mt-3 mb-3">
                    <li className="list-group-item">
                        <strong>Track Id: </strong> {track.track_id}
                    </li>
                    <li className="list-group-item">
                        <strong>Album Name: </strong> {track.album_name}
                    </li>
                </ul>
            </React.Fragment>
        )
    }
}
